import { BsMetaUtil, useOraclePrices, UserExternalRewardsPnlInfoExpanded } from "@bridgesplit/abf-react";
import { Column, StatColumn, StatProps, Text } from "@bridgesplit/ui";
import { TokenAmountWithUsd } from "app/components/common";
import { Hidable } from "@bridgesplit/utils";

import { useVaultContext } from "../VaultContext";

export function VaultExternalRewardsHeader() {
    const { userExternalRewardsPosition: userPositionPnl, userPositionLoading } = useVaultContext();
    const stats = useVaultExternalRewardsStats({ externalRewards: userPositionPnl });
    return (
        <Column spacing={2}>
            <Text variant="h4">Rewards</Text>
            <StatColumn stats={stats} loading={userPositionLoading} />
        </Column>
    );
}

function useVaultExternalRewardsStats({
    externalRewards
}: {
    externalRewards: UserExternalRewardsPnlInfoExpanded[] | undefined;
}): StatProps[] | undefined {
    const mints = externalRewards?.map((reward) => reward.rewardMetadata.mint);
    const { getUsdPrice } = useOraclePrices(mints);
    if (!externalRewards) return undefined;

    const stats: Hidable<StatProps>[] = [];

    for (const reward of externalRewards) {
        const usdPrice = getUsdPrice(reward.rewardMetadata.mint);
        const symbol = BsMetaUtil.getSymbol(reward.rewardMetadata);

        const stat: StatProps = {
            value: (
                <TokenAmountWithUsd
                    amount={reward.claimedRewards}
                    token={reward.rewardMetadata}
                    condensedOnMobile
                    display="symbol"
                    amountUsd={reward.claimedRewards * (usdPrice ?? 0)}
                />
            ),
            caption: `Total ${symbol} claimed`,
            hide: reward.claimedRewards === 0 && reward.pendingRewards === 0 //Hide if no rewards are claimed or pending
        };

        if (stat) {
            stats.push(stat);
        }
    }

    return stats.filter((stat) => !stat.hide);
}
